import MarkerClusterer from "@googlemaps/markerclustererplus";

// default icons
import m1 from "../markers/m1.png";
import m2 from "../markers/m2.png";
import m3 from "../markers/m3.png";

/**
 * create cluster for marker on map
 */
class Cluster {
  /**
   * instance of google map
   */
  _map = null;

  /**
   * array of google marker
   */
  _markers = [];

  /**
   * MarkerClusterer instance
   */
  _markerCluster = null;

  /**
   * options for clusters
   */
  _options = {};

  /**
   * styles for marker clusterer
   */
  _styles = [];

  /**
   *
   * @param {Google Map instance} map
   * @param {array} markers - array of google marker
   * @param {object} options - options for cluster
   * @param {array} styles - styles for marker cluster
   */
  constructor(map = null, markers = [], options, styles) {
    if (map === null || map === undefined) {
      throw new Error("map is not defined");
    }
    if (markers === null || Array.isArray(markers) === false) {
      throw new Error("markers is not a array");
    }
    this._map = map;
    this._markers = markers;
    this._styles = styles || [
      MarkerClusterer.withDefaultStyle({
        width: 52,
        height: 52,
        url: m1,
        textSize: 12
      }),
      MarkerClusterer.withDefaultStyle({
        width: 52,
        height: 52,
        url: m2,
        textSize: 12
      }),
      MarkerClusterer.withDefaultStyle({
        width: 52,
        height: 52,
        url: m3,
        textSize: 12
      })
    ];

    this._options = {
      styles: this._styles,
      maxZoom: 13,
      gridSize: 50,
      minimumClusterSize: 2,
      zoomOnClick: true,
      ...options
    };

    this._createCluster();
  }

  /**
   * Create instance MarkerClusterer
   */
  _createCluster = () => {
    this._markerCluster = new MarkerClusterer(
      this._map,
      this._markers,
      this._options
    );
  };

  /**
   * clear all markers on cluster
   */
  clearMarkers = () => {
    this._markerCluster.clearMarkers();
  };
}

export default Cluster;
